import React from 'react';
import { Group, MapPin } from 'iconoir-react';

interface GroupData {
  id: string;
  name: string;
  description: string;
  rules: string;
  location: string;
  avatar?: string;
  coverImage?: string;
  memberCount: number;
}

interface GroupCardProps {
  group: GroupData;
  onClick: () => void;
}

const GroupCard: React.FC<GroupCardProps> = ({ group, onClick }) => {
  return (
    <div 
      className="w-full px-4 py-2 inline-flex flex-col justify-start items-start gap-2.5 cursor-pointer"
      onClick={onClick}
    >
      <div className="self-stretch h-80 relative glass-primary hover-lift">
        <div className="w-full h-36 left-0 top-0 absolute rounded-md">
          <img 
            className="w-full h-36 left-0 top-0 absolute rounded-tl-md rounded-tr-md object-cover" 
            src={group.coverImage || "https://placehold.co/343x152"} 
            alt="Group cover"
          />
          <div className="size- p-3 right-2 top-2 absolute glass-secondary rounded-full inline-flex justify-start items-center gap-2.5">
            <div className="size-6 relative overflow-hidden">
              <div className="size-2 left-[8.25px] top-[8.25px] absolute bg-midnight-blue" />
              <div className="size-5 left-[1.25px] top-[1.25px] absolute bg-midnight-blue" />
            </div>
          </div>
        </div>
        <div className="w-full py-4 left-3 top-[82px] absolute inline-flex justify-start items-center gap-9">
          <div className="size- inline-flex flex-col justify-start items-start gap-2">
            <div className="size-24 relative">
              <img 
                className="size-24 left-0 top-0 absolute rounded-full outline outline-[3px] outline-[#FBF6F1] object-cover" 
                src={group.avatar || "https://placehold.co/100x100"} 
                alt="Group avatar"
              />
            </div>
            <div className="size- flex flex-col justify-start items-start gap-1.5">
              <div className="justify-start text-[#1E3A3A] text-2xl font-semibold font-manrope leading-7">
                {group.name}
              </div>
              <div className="size- flex flex-col justify-start items-start gap-1.5">
                <div className="justify-start text-[#6F6F6B] text-xs font-normal font-sora leading-none">
                  {group.description}
                </div>
                <div className="size- flex flex-col justify-start items-start gap-2">
                  <div className="size- inline-flex justify-start items-center gap-1">
                    <div className="size-4 relative overflow-hidden">
                      <Group className="w-4 h-4 text-[#6F6F6B]" />
                    </div>
                    <div className="justify-start text-[#6F6F6B] text-xs font-normal font-sora leading-none">
                      {group.memberCount} thành viên
                    </div>
                  </div>
                  <div className="size- inline-flex justify-start items-center gap-1">
                    <div className="size-3.5 relative overflow-hidden">
                      <MapPin className="w-3.5 h-3.5 text-[#6F6F6B]" />
                    </div>
                    <div className="justify-start text-[#6F6F6B] text-xs font-normal font-sora leading-none">
                      {group.location}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupCard;
